import React from "react";
import { Input } from "antd";
import { LockOutlined } from "@ant-design/icons";

const PasswordStep = ({
  password,
  confirmPassword,
  handlePasswordChange,
  handleConfirmPasswordChange,
  passwordErrors,
}) => {
  return (
    <div className="step-content">
      <h3>Create Password</h3>

      <Input.Password
        prefix={<LockOutlined />}
        placeholder="Enter your password"
        value={password}
        onChange={handlePasswordChange}
        className="signup-input"
        style={{ marginBottom: 10 }}
      />

      <Input.Password
        prefix={<LockOutlined />}
        placeholder="Confirm your password"
        value={confirmPassword}
        onChange={handleConfirmPasswordChange}
        className="signup-input"
        style={{ marginBottom: 10 }}
      />

      {/* ✅ password rule feedback */}
      <p style={{ fontSize: "13px", color: passwordErrors.isValidLength ? "green" : "red" }}>
        Password must be at least 4 characters long
      </p>
    </div>
  );
};

export default PasswordStep;
